import classNames from "classnames";
import Size from "shared/enums/Size";
import { CheckBoxConfig } from "../types";
import Variant from "shared/enums/Variant";
import { InputType } from "shared/form/enum";
import ToolTip from "shared/components/tooltip";
import DisplayIcon from "../displayIcon";
import { ConflictTag } from "shared/form/fields/overwriteField/components/conflictTag";
import { ConflictTagType } from "shared/form/renderer/enums/Conflict";

function getClassNames(args: {
  size?: Size;
  block?: boolean;
  variant?: Variant;
  className?: string;
  disabled?: boolean;
}) {
  return classNames(args.className, {
    checkbox: true,
    "checkbox--block": args.block,
    [`checkbox--${args.size}`]: args.size,
    [`checkbox--${args.variant}`]: args.variant,
    "checkbox--disabled": args.disabled || false
  });
}

function CheckBox(props: CheckBoxConfig) {
  const computedClassNames = getClassNames({
    size: props.size,
    block: props.block,
    variant: props.variant,
    disabled: props.disabled,
    className: props.className
  });

  //TODO:SR apply css for tooltip
  return (
    <div className={computedClassNames} title={props.title}>
      <label>
        <input
          className="checkbox_input"
          type={InputType.CHECKBOX}
          onChange={props.onChange}
          onBlur={props.onBlur}
          disabled={props.disabled}
          autoComplete={props.autoComplete}
          autoFocus={props.autoFocus}
          placeholder={props.placeholder}
          checked={props.checked}
          name={props.name}
        />
        <b></b>
        {props.label && (
          <span className={classNames("checkbox_text", props.classNameForLabel)}>
            {props.iconUrl && <DisplayIcon iconUrl={props.iconUrl} />}
            <span className="checkbox_text--value">
              {props.label}
              {!props.checked && props.conflictTagType === ConflictTagType.DELETED_VALUE && (
                <ConflictTag conflictTagType={ConflictTagType.DELETED_VALUE} />
              )}
              {props.checked && props.conflictTagType === ConflictTagType.NEW_VALUE && (
                <ConflictTag conflictTagType={ConflictTagType.NEW_VALUE} />
              )}
              {props.tooltipContent && <ToolTip size={Size.SMALL} content={props.tooltipContent} />}
            </span>
          </span>
        )}
      </label>
    </div>
  );
}

export default CheckBox;
